import React, { useEffect, useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';

const StudentCardsPrint = () => {
    const [students, setStudents] = useState([]);

    useEffect(() => {
        const storedStudents = localStorage.getItem('print_students');
        if (storedStudents) {
            setStudents(JSON.parse(storedStudents));
        }

        const timer = setTimeout(() => {
            window.print();
        }, 1000);

        return () => clearTimeout(timer);
    }, []);

    if (students.length === 0) {
        return <div className="p-10 text-center font-bold text-red-500">لا يوجد تلاميذ محددين للطباعة!</div>;
    }

    const primaryColor = "#eea508";

    return (
        <div className="print-container">
            {students.map((student) => (
                <div key={student.id} className="student-card">
                    {/* القسم الأيمن: البيانات وإطار الصورة */}
                    <div className="card-right-section">
                        <div className="header-area">
                            <img src="/logo.png" alt="Logo" className="association-logo" />
                            <div className="association-info">
                                <h2 className="association-name">
                                     جمعية تنمية النقل المدرسي ولاد دحو
                                </h2>
                            </div>
                        </div>

                        <div className="student-data-area">
                            <div className="data-row main-name">
                                <span className="label">الاسم الكامل:</span>
                                <span className="value bold-name">{student.full_name}</span>
                            </div>
                            <div className="data-grid" style={{ gridTemplateColumns: '1fr' }}>
                                <div className="data-row">
                                    <span className="label">المنطقة:</span>
                                    <span className="value">{student.region?.region_name || '-'}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* القسم الأيسر: الـ QR Code فقط */}
                    <div className="card-left-side" style={{ backgroundColor: primaryColor }}>
                        <div className="qr-section">
                            <div className="qr-wrapper-white">
                                <QRCodeSVG 
                                    value={student.qr_code || student.qr_code} 
                                    size={80} 
                                    level="H"
                                    fgColor="#000"
                                />
                            </div>
                            <b>
                                <h4 className="qr-id-text" style={{'color' : 'black','font-size' : '15px'}}>{student.qr_code}</h4>
                            </b>
                        </div>
                        {/* تم حذف قسم الشعار من هنا */}
                    </div>
                </div>
            ))}

            <style dangerouslySetInnerHTML={{__html: `
                @import url('https://fonts.googleapis.com/css2?family=Noto+Kufi+Arabic:wght@100..900&display=swap');
                @page {
                    size: A4;
                    margin: 0;
                }
                body {
                    margin: 0;
                    padding: 0;
                    background: #f0f0f0;
                    font-family: 'Noto Kufi Arabic', sans-serif;
                    -webkit-print-color-adjust: exact !important;
                    print-color-adjust: exact !important;
                }
                .print-container {
                    padding: 10mm;
                    display: grid;
                    grid-template-columns: repeat(2, 1fr);
                    gap: 12mm 6mm;
                    direction: rtl;
                }
                .student-card {
                    width: 9.5cm;
                    height: 5.5cm;
                    background: white;
                    display: flex;
                    border: 1px solid #ccc;
                    position: relative;
                    overflow: hidden;
                    page-break-inside: avoid;
                }
                /* القسم الأيمن */
                .card-right-section {
                    flex: 1;
                    padding: 12px 15px;
                    display: flex;
                    flex-direction: column;
                }
                .header-area {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    margin-bottom: 12px;
                }

                .association-info {
                    display: flex;
                    flex-direction: column;
                    flex: 1;
                }
                .association-logo {
                    height: 45px; /* Increased size since it has more room */
                    object-fit: contain;
                }
                .association-name {
                    margin: 0;
                    font-size: 11px;
                    font-weight: 800;
                    color: #333;
                    line-height: 1.2;
                }
                .association-location {
                    margin: 0;
                    font-size: 12px;
                    font-weight: 900;
                    line-height: 1.2;
                }
                .student-data-area {
                    border-top: 2px solid #f1f1f1;
                    padding-top: 10px;
                    margin-top: auto; /* يدفع البيانات للأسفل */
                }
                .data-row {
                    margin-bottom: 6px;
                }
                .data-row .label {
                    font-size: 10px;
                    color: #666;
                    margin-left: 5px;
                    display: block;
                }
                .data-row .value {
                    font-size: 12px;
                    color: #333;
                    font-weight: 700;
                }
                .bold-name {
                    font-size: 17px !important;
                    color: #000 !important;
                }
                .data-grid {
                    display: grid;
                    grid-template-columns: 1.2fr 0.8fr;
                    margin-top: 5px;
                    gap: 5px;
                }
                
                /* القسم الأيسر - تم تبسيطه ليحتوي على الـ QR فقط */
                .card-left-side {
                    width: 105px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center; /* الـ QR في المنتصف */
                    align-items: center;
                    padding: 15px 10px;
                }
                
                .qr-section {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                }
                .qr-wrapper-white {
                    background: white;
                    padding: 6px;
                    border-radius: 6px;
                }
                .qr-id-text {
                    color: white;
                    font-size: 9px;
                    font-weight: bold;
                    margin-top: 6px;
                    font-family: monospace;
                }

                @media print {
                    body { background: white; }
                    .student-card {
                        border: 1px solid #000;
                    }
                    /* إزالة الصورة تماماً */
                }
            `}} />
        </div>
    );
};

export default StudentCardsPrint;